import { defineComponent as _, useCssModule as p, inject as d, createElementBlock as a, openBlock as c, normalizeClass as u, unref as t, createCommentVNode as f, renderSlot as y, toDisplayString as b } from "vue";
import "lodash-es/cloneDeep";
import "lodash-es/get";
import "lodash-es/uniqueId";
import "./DataView.keys-aSOnA4AD.js";
import "./Illustration.vue_vue_type_script_setup_true_lang-BBqgoJO8.js";
import "@leaflink/snitch";
import { T as w } from "./Table.keys-LHQf6FEH.js";
import { _ as x } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const h = {
  key: 0,
  class: "tw-text-xs tw-font-medium tw-text-ice-900 lg:tw-hidden"
}, C = /* @__PURE__ */ _({
  __name: "TableCell",
  props: {
    isControl: { type: Boolean, default: !1 },
    mobileHeader: { default: "" }
  },
  setup(n) {
    const l = n, o = p(), r = d(w.key);
    if (!r)
      throw new Error("TableCell must be used within a Table component");
    const { density: e, hasActions: i, layout: s } = r;
    return (m, B) => (c(), a("td", {
      class: u(["stash-table-cell", [
        t(o).root,
        t(o)[`layout--${t(s)}`],
        {
          [t(o)["root--density-compact"]]: t(e) === "compact",
          [t(o)["root--density-comfortable"]]: t(e) === "comfortable",
          [t(o)["has-actions"]]: t(i),
          "tw-p-3": t(s) === "scroll",
          "tw-p-1.5": t(s) === "stack",
          "lg:tw-p-3": t(e) === "compact",
          "lg:tw-px-3 lg:tw-py-6": t(e) === "comfortable",
          [t(o)["is-control"]]: l.isControl
        }
      ]]),
      "data-test": "stash-table-cell"
    }, [
      l.mobileHeader && t(s) === "stack" ? (c(), a("div", h, b(l.mobileHeader), 1)) : f("", !0),
      y(m.$slots, "default")
    ], 2));
  }
}), k = "_root_rmarx_2", T = {
  root: k,
  "layout--scroll": "_layout--scroll_rmarx_6",
  "has-actions": "_has-actions_rmarx_12",
  "layout--stack": "_layout--stack_rmarx_16",
  "is-control": "_is-control_rmarx_28",
  "root--density-comfortable": "_root--density-comfortable_rmarx_52"
}, g = {
  $style: T
}, v = /* @__PURE__ */ x(C, [["__cssModules", g]]);
export {
  v as default
};
//# sourceMappingURL=TableCell.js.map
